import script from "./ParticipantPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantPicker.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantPicker.vue?vue&type=style&index=0&id=0c899a57&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c899a57"]])

export default __exports__